import React from "react";
import PageLayout from "../PageLayout/PageLayout";
import AboutUsHeroSection from "./AboutUsHeroSection";
import MissionSection from "./MissionSection";
import ValuesSection from "./ValuesSection";
import FounderSection from "./FounderSection";
import VisionSection from "./VisionSection";
import "./AboutPage.css";

export default function AboutUs() {
  return (
    <div className="about-page">
      <PageLayout fullBleed>
        <AboutUsHeroSection />
        <MissionSection />
        <ValuesSection />
        <FounderSection />
        <VisionSection />
      </PageLayout>
    </div>
  );
}
